<template>
    <model-select :options="options"
                  v-model="item"
                  class="input"
                  placeholder="Select Market">
    </model-select>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
export default {
   components: {
           ModelSelect
   },
   computed: {
       options() {
           let markets = this.$store.getters.getProfitSectionData.markets

           let list = []

           markets.forEach(function(element) {
               list.push({
                   value: element.id,
                   text: element.country
               })
           })

           return list
       },
       item: {
           get() {
               return this.$store.getters.getProfitSectionData.market_id
           },
           set(value) {
               this.$store.dispatch('setProfitSectionFieldValue', { field: 'market_id', value: value })
           }
       },
       isLoading() {
           return this.$store.getters.getProfitSectionData.is_loading
       }
   },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/Profit/ProfitMarketSelect.vue